import React from 'react';

const WordCount = ({ charCount, maxChar }) => {
  return (
    <div className={'word-count ' + (charCount === maxChar ? 'stop' : '')}>
      ({charCount}/{maxChar})
    </div>
  );
};

export default WordCount;



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Editors/Highlights/WordCount.jsx